import { atom } from 'jotai';

export const streamsWithOffsetRequiredAtom = atom([]);
streamsWithOffsetRequiredAtom.debugLabel = 'streamsWithOffsetRequired';

export default { streamsWithOffsetRequiredAtom };
